var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRunwayView = function SvgRunwayView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.201 19.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.6.6v1m0 4v2m0 4v2m0 4v1m6.385-16.492 3.553 14a2 2 0 0 1-1.939 2.492H2.601a2 2 0 0 1-1.938-2.492l3.553-14A2 2 0 0 1 6.154.6h8.892a2 2 0 0 1 1.939 1.508"
  })));
};
export default SvgRunwayView;